import axiosInstance from '../../../lib/api/axios';
import { getServerUrl } from '../../../lib/utils';
import { SortOrders } from '../types';
import { SortableAccountInvitationColumns, CreateAccountInvitationPayload, AccountInvitation, GetAccountInvitationsResponse } from './types';

export const sendInvitations = async (payload: CreateAccountInvitationPayload): Promise<void> => {
  await axiosInstance.post(`${getServerUrl()}/accountInvitations`, { ...payload });
};

export const getInvitations = async (
  page: number,
  perPage: number,
  query?: string,
  sortBy?: SortableAccountInvitationColumns,
  sortOrder?: SortOrders,
): Promise<GetAccountInvitationsResponse> => {
  const params = {
    page,
    perPage,
    query,
    ...(sortBy && {
      sortBy,
    }),
    ...(sortOrder && {
      sortOrder,
    }),
  };
  const { data } = await axiosInstance.get(`${getServerUrl()}/accountInvitations`, { params });
  return data;
};

export const deleteInvitation = async (id: number): Promise<void> => {
  await axiosInstance.delete(`${getServerUrl()}/accountInvitations/${id}`);
  return;
};